<template>
  <div class="module module-page">
    <div class="main-container">
      <header>
        <div class="header-container">
          <div class="title">
            <h1><slot name="title"></slot></h1>
          </div>
          <div>
            <slot name="header-buttons"></slot>
          </div>
        </div>
      </header>
      <main>
        <slot></slot>
        <shim v-if="showingModal">
          <div class="modal fixed-height">
            <slot name="modal"></slot>
          </div>
        </shim>
        <shim v-if="error">
          <div class="modal">
            <error>{{ error }}</error>
          </div>
        </shim>
      </main>
    </div>
    <footer>
      <slot name="footer"></slot>
    </footer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Shim from "@/components/common/Shim.vue";
import Error from "@/components/common/Error.vue";

export default {
  components: { Shim, Error },
  computed: {
    ...mapState({
      error: (state) => state.error,
    }),
    showingModal: function() {
      // Vue 3: $slots returns functions, not arrays
      // Comment vnodes (from v-if=false) have Symbol type, real elements have string/object type
      if (!this.$slots.modal) return false;
      const slots = this.$slots.modal();
        return slots && slots.some((vnode) => {
        // Filter out Comment nodes (v-if=false creates these)
        // Real components have object type, real elements have string type
        return vnode.type && typeof vnode.type !== 'symbol';
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  & > .title {
    white-space: nowrap;

    & > h1 {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      margin: 0 10px 0 0;
    }
  }
}
</style>
